import { accountingType } from '@/features/master-table/models';
import {
  BudgetTypeEnum,
  amountDifferenceOperator,
  amountDifferenceUnit,
  budgetAmountTypeEnum,
} from '@/features/project/_models/project-filter';
import { booleanStringType } from '@/utils';
import {
  fundSheetTypeEnum,
  implementationMethodEnum,
  projectCategoryEnum,
  reviewTypeEnum,
  sheetTypeEnum,
} from '@/utils/enum';
import {
  parseAsArrayOf,
  parseAsBoolean,
  parseAsInteger,
  parseAsString,
  parseAsStringLiteral,
  useQueryStates,
} from 'nuqs';
import {
  amountSearchTypeEnum,
  candidateOfInspectionByExternalExpert,
  initialValueOfProjectSearchForm,
} from '../_models/projects-search';

export const projectListSearchNuqs = {
  page: parseAsInteger.withDefault(1),
  pageSize: parseAsInteger.withDefault(30),
  fiscalYear: parseAsString.withDefault(
    initialValueOfProjectSearchForm.fiscalYear.toString(),
  ),
  sheetType: parseAsStringLiteral(sheetTypeEnum.options).withDefault('RS'),
  fundSheetType: parseAsStringLiteral(fundSheetTypeEnum.options),
  q: parseAsString,
  // テキスト検索対象
  isSearchTargetProjectName: parseAsBoolean.withDefault(false),
  cascader: parseAsString,
  corporateNumber: parseAsString,
  categories: parseAsArrayOf(parseAsStringLiteral(projectCategoryEnum.options)),
  implementationMethods: parseAsArrayOf(
    parseAsStringLiteral(implementationMethodEnum.options),
  ),
  accountingType: parseAsStringLiteral(accountingType.options),
  accountingTypeIds: parseAsArrayOf(parseAsString),
  skipAdministrativeReformTeamEvaluation: parseAsStringLiteral([
    ...booleanStringType.options,
    'all',
  ]).withDefault(
    initialValueOfProjectSearchForm.skipAdministrativeReformTeamEvaluation,
  ),
  projectNumbers: parseAsString,
  isPublished: parseAsStringLiteral(booleanStringType.options),
  inspectionByExternalExpertReviewType: parseAsArrayOf(
    parseAsStringLiteral(reviewTypeEnum.options),
  ),
  isCandidateOfInspectionByExternalExpert: parseAsStringLiteral(
    candidateOfInspectionByExternalExpert.options,
  ),
  // 数式条件（後方互換性のため残す）
  amountSearchType: parseAsStringLiteral(amountSearchTypeEnum.options),
  amountSearchDiffAmount: parseAsInteger,
  amountSearchDiffAmountUnit: parseAsStringLiteral(
    amountDifferenceUnit.options,
  ),
  amountSearchDiffOperator: parseAsStringLiteral(
    amountDifferenceOperator.options,
  ),
  amountSearchBaseTargetYear: parseAsString,
  amountSearchRightTargetYear: parseAsString,
  amountSearchBaseBudgetType: parseAsStringLiteral(BudgetTypeEnum.options),
  amountSearchRightBudgetType: parseAsStringLiteral(BudgetTypeEnum.options),
  amountSearchBaseAmountType: parseAsStringLiteral(
    budgetAmountTypeEnum.options,
  ),
  amountSearchRightAmountType: parseAsStringLiteral(
    budgetAmountTypeEnum.options,
  ),
  amountSearchFilterType: parseAsStringLiteral(['total']),
  ordering: parseAsString,
  // 事業年度（作成年度）
  startYear: parseAsInteger,
  endYear: parseAsInteger,
  // 点検最終実施年度
  lastImplementedFiscalYearRangeMax: parseAsInteger,
  lastImplementedFiscalYearRangeMin: parseAsInteger,
  // PS用
  organizationIds: parseAsArrayOf(parseAsString),
  otherResponsibleOrganizationIds: parseAsArrayOf(parseAsString),
  policyIds: parseAsArrayOf(parseAsString),
  expenditureBudgetPurposeIds: parseAsArrayOf(parseAsString),
  // 複数数式条件用
  formula_conditions: parseAsString,
};

export const useProjectListSearchQueryStates = () => {
  const [searchQueryStates, setSearchQueryStates] = useQueryStates(
    projectListSearchNuqs,
  );
  return { searchQueryStates, setSearchQueryStates };
};

export type ProjectsSearchQueryStates = ReturnType<
  typeof useProjectListSearchQueryStates
>['searchQueryStates'];
